var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegistrationNumberIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2 12.5V24.5C21.2 25.6046 20.3045 26.5 19.2 26.5H2.69995C1.59538 26.5 0.699951 25.6046 0.699951 24.5V3C0.699951 1.89543 1.59538 1 2.69995 1H19.7C20.5284 1 21.2 1.67157 21.2 2.5M16.2 5.5H3.19995M3.19995 9.5H12.7M10.3905 13.5H3.19995M3.19995 18H12.2M18.7 21.7528H3.19995",
    stroke: "#11334E",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7717 12L12.7 16L16.7 14.9282M13.7717 12L16.7 14.9282M13.7717 12L23.4966 2.27514M16.7 14.9282L26.4248 5.20336M26.4248 5.20336L27.2358 4.39233C28.0444 3.58373 28.0444 2.27272 27.2358 1.46411C26.4272 0.655505 25.1162 0.655504 24.3076 1.46411L23.4966 2.27514M26.4248 5.20336L23.4966 2.27514",
    stroke: "#11334E",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistrationNumberIcon1);
export default __webpack_public_path__ + "static/media/registrationNumberIcon1.3f08b73748c09b18223b3d685233da09.svg";
export { ForwardRef as ReactComponent };